import type { DashboardRepository } from '@/core/infrastructure/repositories/dashboard/DashboardRepository.ts'
import type { DashboardClassroomDiagnosticTrigger } from '@/core/domain/dashboard/DashboardClassroomDiagnosticTrigger.ts'
import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository.ts'

export class FetchAllDashboardClassroomDiagnosticTriggerUseCase {
  private readonly dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: DashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(classroomId: number): Promise<DashboardClassroomDiagnosticTrigger[]> {
    return await this.dashboardRepository.fetchAllDashboardClassroomDiagnosticTriggersByClassroomId(
      classroomId
    )
  }
}
